export const incrBoxId = boxId => boxId.split(' ')[0] + ' ' + (Number(boxId.split(' ')[1]) + 1);